import { Modal, Space, Card, Row, Col, Flex, Button } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as PDFIcon } from "../../../../assets/icon/pdfIcon.svg";
import { ReactComponent as DownloadICon } from "../../../../assets/icon/downloadIcon.svg";

function Section50BisModal({
    isModalOpen,
    setIsModalOpen,
    exportSection50BisReportReportPdf = () => { }
}) {
    const { t, i18n } = useTranslation();

    return (
        <Modal
            title={<span color="#42526D">{t("report.label.download_file")}</span>}
            destroyOnClose
            open={isModalOpen}
            footer={null}
            closable={false}
            maskClosable={false}
        >
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <span style={{ fontSize: "14px", color: "#667085" }}>
                    {t("report.modal.description")}
                </span>

                <Card
                    style={{ backgroundColor: "#F5F6F7", border: "1px solid #E4E7EC", borderRadius: "12px" }}
                    styles={{ body: { padding: "16px" } }}
                >
                    <Row style={{ width: "100%" }}>
                        <Col span={16}>
                            <Flex gap={16} align="center">
                                <PDFIcon />
                                <Flex vertical>
                                    <span style={{ fontWeight: "bold", color: "#42526D" }}>{t("employee_payroll_report.header")}</span>
                                    <span style={{ color: "#42526D" }}>{t("common.pdf_file")}</span>
                                </Flex>
                            </Flex>
                        </Col>
                        <Col span={8} style={{ alignContent: "center", textAlignLast: "right" }}>
                            <Button type="default" style={{ height: "40px", borderRadius: "8px" }} onClick={() => { exportSection50BisReportReportPdf() }}>
                                <Flex gap={8}>
                                    <DownloadICon />
                                    <span style={{ color: "#59687F", fontWeight: "bold" }}>{t("common.download")}</span>
                                </Flex>
                            </Button>
                        </Col>
                    </Row>
                </Card>
                <Row justify={"end"}>
                    <Button style={{ borderRadius: "8px", height: "40px" }} type="default" onClick={() => { setIsModalOpen(false) }}>
                        <span style={{ fontWeight: "bold", color: "#344054" }}>{t("common.cancel").toUpperCase()}</span>
                    </Button>
                </Row>
            </Space>
        </Modal>
    )
}

export default Section50BisModal;